module.exports = "<div ng-if=\"AddInfoCtrl.data.title\">\n    <h1 class=\"h3 mtxl\" >{{ AddInfoCtrl.data.title }}</h1>\n\n    <div class=\"table-container\">\n    \t<table class=\"table-info\">\n    \t\t<tbody>\n    \t\t\t<tr ng-repeat=\"(key, item) in ::AddInfoCtrl.data.items\">\n    \t\t\t\t<td class=\"table-cell pts prs pbs one-third\"><strong>{{ ::key }}</strong></td>\n    \t\t\t\t<td class=\"table-cell pts prs pbs\">{{ ::item | currency:USD }}</td>\n    \t\t\t</tr>\n    \t\t</tbody>\n    \t</table>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/templates/bits/myaccount_additional_header.html
// module id = 96
// module chunks = 0